import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const ContactCTA = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <section className="bg-gradient-to-r from-textBlue to-primaryBlue py-16 px-6 md:px-16 sm:px-4">
      <div className="max-w-4xl mx-auto text-center text-white">
        <h2 className="text-4xl md:text-3xl sm:text-2xl font-bold mb-4">
          {t("cta.title")}
        </h2>
        <p className="text-xl md:text-lg sm:text-base mb-8 opacity-90">
          {t("cta.description")}
        </p>
        <button
          onClick={() => navigate("/contact")}
          className="bg-bgYellow text-black px-8 py-3 rounded-full font-semibold hover:bg-yellow-500 transition-all transform hover:scale-105"
        >
          {t("cta.button")}
        </button>
      </div>
    </section>
  );
};

export default ContactCTA;
